<template>
    <div>
        <home-head :show-menu="false"/>
        <div style="margin: 30px; height: 100vh" v-if="login == 0">
            <div style="text-align: center;font-size: 2rem;margin: 30vh  0  2rem 0">登录</div>
            <ant-form validate-first @submit="onSubmit">
                <ant-field label="姓名："
                           required
                           v-model="form.username" placeholder="请输入内容"/>
                <ant-field label="联系方式："
                           v-model="form.phone"
                           required type="tel"
                           placeholder="请输入联系方式"
                           :rules="[{ required: true, message: '请填写正确联系方式' }]"/>
                <ant-field label="身份证号："
                           v-model="form.idNumber"
                           required
                           placeholder="请输入身份证号"
                           :rules="[{ required: true, message: '请填写正确身份证号' }]"/>
                <div style="margin: 16px;">
                    <ant-button block type="danger" native-type="submit">
                        提交
                    </ant-button>
                </div>
            </ant-form>
        </div>
        <event-registration v-else :proId="proId" :openid="form.openid"/>
    </div>
</template>

<script>
    import service from "../../api/service";
    import eventRegistration from "../move/eventRegistration";
    import {NavBar, Field, Form, Button, Toast} from 'vant';
    import homeHead from "../../common/homeHead";
    import {Notify} from 'vant';

    export default {
        name: "appIndex",
        components: {
            NavBar, AntField: Field, AntForm: Form, AntButton: Button, eventRegistration, homeHead,Toast
        },
        data() {
            return {
                login: 0,
                proId: '',
                form: {
                    openid: "",
                    accessToken: "",
                    phone: "",
                    idNumber: ""
                }
            }
        },
        mounted() {
            this.getQuery()
        },
        methods: {
            getQuery() {
                let query = this.$route.query
                if (query) {
                    if (query.openid) {
                        this.form.openid = query.openid
                        sessionStorage.setItem("openid", query.openid)
                        service.get('/api/xw/getUserById',{
                            openId:query.openid
                        }).then(res=>{
                            if (res.status ===200){
                                sessionStorage.setItem("phone",res.data.user.phone)
                                sessionStorage.setItem("id",res.data.user.id)
                                sessionStorage.setItem("deptId",res.data.user.deptId)
                            }
                        })
                    }
                    if (query.access_token) {
                        this.form.accessToken = query.access_token
                        this.$store.state.accessToken = query.accessToken
                    }
                    if (query.id) {
                        this.proId = query.id
                        sessionStorage.setItem("proId",query.id)
                    }
                    if (query.login) this.login = query.login
                }
            },
            //登录
            onSubmit() {
                let form = {...this.form}
                service.post('/api/gzh/login', form).then(res => {
                    if (res.status === 200) {
                        Toast.success("登录成功")
                        this.login = 1
                    } else {
                        Toast.fail(res.message)
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>